<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="企业名称"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.hasReferral"
              label="是否可以内推"
              :options="hasReferralOptions"
              :messages="message"
              :error="!!error.hasReferralErrors.length"
              :error-messages="error.hasReferralErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.createTime">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.logo.length!==0">
            <va-card
              overlay
              :image='insertData.logo'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='企业logo'>
              <va-file-upload
                type='single'
                v-model='insertData.logoArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
        </div>

        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../utils/common'
import uploadApi from '../../api/upload'
import organizationApi from '../../api/organization'
import { HAS_REFERRAL } from '@/utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        logo: '',
        logoArr: [],
        sortNum: 1,
        hasReferral: 0,
        createTime: '',
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        sortNumErrors: [],
        hasReferralErrors: [],
      },
      showId: false,
      title: '创建企业',
      submitButtonStatus: true,
      hasReferralOptions: HAS_REFERRAL.map(x => x.TEXT),
    }
  },
  created () {
    this.getOrganization()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.hasReferralErrors.length
    },
  },
  methods: {
    getOrganization () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑企业'
        // 通过id获取详情
        organizationApi.getOrganization(params.id).then(response => {
          copyObject(response.organization, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          HAS_REFERRAL.forEach(x => {
            if (x.CODE === this.insertData.hasReferral) {
              this.insertData.hasReferral = x.TEXT
            }
          })
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        logo: this.insertData.logo,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      HAS_REFERRAL.forEach(x => {
        if (x.TEXT === this.insertData.hasReferral) {
          data.hasReferral = x.CODE
        }
      })
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        organizationApi.updateOrganization(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('企业更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listOrganization' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        organizationApi.saveOrganization(data).then(response => {
          if (response.success === true) {
            this.showToast('添加企业成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listOrganization' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.hasReferralErrors = this.insertData.hasReferral ? [] : ['hasReferral is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    uploadImage () {
      if (this.insertData.logoArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.logoArr[this.insertData.logoArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.logo = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
